import { Link, Stack, Typography } from '@mui/material';

import type { ConversationalFormExplanation } from '@karehero/models';

import { BottomSheetDialog } from '@/pwa/atoms/BottomSheetDialog/BottomSheetDialog';

export interface ExplanationSheetProps {
  /** Omit to close it. */
  explanation?: ConversationalFormExplanation;
  onClose: () => void;
  onOpenLink?: (url: string) => void;
}

/** ExplanationSheet opens from a row that explains rather than answers: a title, its points and any link. */
export const ExplanationSheet = ({
  explanation,
  onClose,
  onOpenLink,
}: ExplanationSheetProps) => (
  <BottomSheetDialog
    isOpen={!!explanation}
    onClose={onClose}
    title={explanation?.title}
  >
    <Stack spacing={2} sx={{ pb: 3 }}>
      {explanation?.points.map((point) => (
        <Typography key={point} variant='body1' color='text.primary'>
          {point}
        </Typography>
      ))}
      {explanation?.note && (
        <Typography variant='body1' sx={{ color: 'text.primary' }}>
          {explanation.note.lead}{' '}
          <Link
            component='button'
            type='button'
            variant='body1'
            onClick={() =>
              explanation.note && onOpenLink?.(explanation.note.linkUrl)
            }
          >
            {explanation.note.linkLabel}
          </Link>
        </Typography>
      )}
    </Stack>
  </BottomSheetDialog>
);

ExplanationSheet.displayName = 'ExplanationSheet';
export default ExplanationSheet;
